// Generated by Melange

import * as Caml_obj from "melange.js/caml_obj.js";
import * as Caml_string from "melange.js/caml_string.js";
import * as Lui_ai__Model from "lui.ai/model.js";
import * as Mapre_chat__Chat_projection from "../../shared/chat/chat_projection.js";
import * as Mapre_chat__Chat_tool from "../../shared/chat/chat_tool.js";
import * as Mapre_web__Web_types from "./web_types.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function tool_status(param) {
  if (param === undefined) {
    return "unknown";
  }
  switch (param) {
    case /* Pending */ 0 :
      return "pending";
    case /* In_progress */ 1 :
      return "in_progress";
    case /* Completed */ 2 :
      return "completed";
    case /* Failed */ 3 :
      return "failed";
    case /* Unknown */ 4 :
      return "unknown";
  }
}

function tool(t) {
  return {
    call_id: t.id,
    title: Mapre_chat__Chat_tool.title(t),
    tool_kind: "",
    status: tool_status(t.status),
    input: t.input,
    output: t.output,
    output_truncated: false
  };
}

function kind_of(param) {
  switch (param) {
    case /* User */ 0 :
      return /* User */ 0;
    case /* Assistant */ 1 :
      return /* Assistant */ 1;
    case /* Thinking */ 2 :
      return /* Thinking */ 2;
    case /* Tool_call */ 3 :
      return /* Tool_call */ 3;
    case /* Notice */ 4 :
      return /* Notice */ 4;
  }
}

function delivery_of(param) {
  switch (param) {
    case /* Sent */ 0 :
    case /* Pending */ 1 :
      return "sent";
    case /* Uncertain */ 2 :
      return "uncertain";
  }
}

function to_item(workspace, item) {
  return {
    id: item.id,
    kind: kind_of(item.kind),
    text: item.text,
    streaming: item.streaming,
    delivery: delivery_of(item.delivery),
    attachments: Stdlib__List.map((function (param) {
      return {
        attachment_id: param.id,
        name: param.name,
        media_type: param.media_type,
        size: param.size,
        status: "ready",
        path: undefined,
        url: "/api/workspaces/" + (workspace + ("/attachments/" + param.id))
      };
    }), item.attachments),
    tool: Stdlib__Option.map(tool, item.tool),
    payload: undefined,
    truncated: item.truncated
  };
}

function pending_of(attempt) {
  if (attempt.text === "" && Caml_obj.caml_equal(attempt.attachments, /* [] */ 0)) {
    return;
  } else {
    return {
      id: attempt.id,
      text: attempt.text,
      attachments: attempt.attachments,
      failed: attempt.phase === /* Uncertain */ 1
    };
  }
}

function busy(m) {
  return Mapre_chat__Chat_projection.busy(m.commands);
}

function generating(m) {
  if (Mapre_chat__Chat_projection.busy(m.commands)) {
    return Stdlib__Option.fold(false, (function (c) {
      return c.can_send;
    }), m.messages.control);
  } else {
    return false;
  }
}

function attrs_of(item) {
  const match = item.kind;
  const match$1 = item.id;
  if (/* tag */ typeof match !== "object" && typeof match !== "function" && match === /* Tool_call */ 3) {
    const tool = item.tool;
    if (tool !== undefined) {
      return {
        hd: [
          "data-tool-call",
          tool.call_id
        ],
        tl: /* [] */ 0
      };
    } else {
      return /* [] */ 0;
    }
  }
  if (!(match$1.length >= 2 && (Caml_string.get(match$1, 0) === /* 'e' */101 || Caml_string.get(match$1, 0) === /* 'x' */120))) {
    if (match$1.length > 2 && Stdlib__String.sub(match$1, 0, 2) === "c-") {
      return {
        hd: [
          "data-command-id",
          Stdlib__String.sub(match$1, 2, match$1.length - 2 | 0)
        ],
        tl: /* [] */ 0
      };
    } else {
      return /* [] */ 0;
    }
  }
  const seq = Stdlib.int_of_string_opt(Stdlib__String.sub(match$1, 1, match$1.length - 1 | 0));
  if (seq !== undefined) {
    return {
      hd: [
        "data-event-seq",
        String(seq)
      ],
      tl: /* [] */ 0
    };
  } else {
    return /* [] */ 0;
  }
}

function projected(m) {
  const pending = Stdlib__Option.bind(m.messages.attempt, pending_of);
  return Mapre_chat__Chat_projection.project(m.events, m.commands, pending, undefined);
}

function items_of(m) {
  const workspace = Stdlib__Option.value(Mapre_web__Web_types.workspace(m.route), "");
  return Stdlib__List.map((function (param) {
    return to_item(workspace, param);
  }), projected(m));
}

function row_count(m) {
  return Stdlib__List.length(Lui_ai__Model.group_rows(true, Stdlib__List.map((function (param) {
    return to_item("", param);
  }), Stdlib__List.filter((function (i) {
    return i.seq !== undefined;
  }), projected(m)))));
}

export {
  items_of,
  busy,
  generating,
  attrs_of,
  row_count,
}
/* Mapre_chat__Chat_projection Not a pure module */
